export function getAspectRatioRangeFromLayout(aspectRatio, layoutData) {
  const aspectRatioIds = Object.keys(layoutData);
  const aspectRatios = aspectRatioIds.map((ar) => {
    const arSplit = ar.split('/');
    return {
      id: ar,
      center: parseFloat(arSplit[0] / arSplit[1]),
    };
  });
  const aspectRatioRanges = aspectRatios.map((aspectRatio, index) => {
    if (index == 0) {
      return {
        ...aspectRatio,
        range: [0, (aspectRatio.center + aspectRatios[1].center) / 2],
      };
    } else if (index == aspectRatios.length - 1) {
      return {
        ...aspectRatio,
        range: [
          (aspectRatio.center + aspectRatios[index - 1].center) / 2,
          +Infinity,
        ],
      };
    } else {
      return {
        ...aspectRatio,
        range: [
          (aspectRatio.center + aspectRatios[index - 1].center) / 2,
          (aspectRatio.center + aspectRatios[index + 1].center) / 2,
        ],
      };
    }
  });

  const range = aspectRatioRanges.find(
    (arr) => aspectRatio >= arr.range[0] && aspectRatio < arr.range[1]
  );

  return range.id;
}
